'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addDays;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/addDays.js
// module id = 466
// module chunks = 0